export default "__VITE_ASSET__292f0ae9__"